import CrossSellReportBuilder from "./builders/CrossSellReportBuilder";
import SoldPoliciesReportBuilder from "./builders/SoldPoliciesReportBuilder";
import UpcomingEffectiveDateReportBuilder from "./builders/UpcomingEffectiveDateReportBuilder";
import OpportunityPipelineReportBuilder from "./builders/OpportunityPipelineReportBuilder";
import PolicyBookOfBusinessReportBuilder from "./builders/PolicyBookOfBusinessReportBuilder";
import SparkImportHistoryReportBuilder from "./builders/SparkImportHistoryReportBuilder";

const reportBuilderRegistry = {
  cross_sell_report: CrossSellReportBuilder,
  sold_policies_report: SoldPoliciesReportBuilder,
  upcoming_effective_date_report: UpcomingEffectiveDateReportBuilder,
  opportunity_pipeline_report: OpportunityPipelineReportBuilder,
  policy_book_of_business_report: PolicyBookOfBusinessReportBuilder,
  spark_import_history_report: SparkImportHistoryReportBuilder
};

export function getReportBuilderComponent(templateKey) {
  return reportBuilderRegistry[templateKey] || null;
}

export default reportBuilderRegistry;